import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { resolveUser } from '@/lib/auth-store'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    const user = await resolveUser()
    if (!user) {
      throw redirect({ to: '/login' })
    }
  },
  component: AuthedLayout,
})

function AuthedLayout() {
  return <Outlet />
}
